import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Upload, Layout, Typography, notification, Select } from "antd";
import { UploadOutlined, SaveOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import axios from "axios";
import { BASE_URL, createProduct, getAllProjectsDropDown, getProjects } from "../../api";
import Logo from "../../assets/images/main-logo-svg.svg";
import './styles.scss'

const { Option } = Select;

const { Header, Content } = Layout;
const { Title } = Typography;

const AddProduct = () => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const history = useNavigate();
    const [projectsLoading, setProjectsLoading] = useState(false);
    const [projects, setProjects] = useState([]);


    console.log({projects})



    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("name", values.name);
            formData.append("price", values.price);
            formData.append("description", values.description);
            formData.append("projectId", values.projectId); 
            console.log('background is', values.background)
            

            if (values.background?.file) {
                formData.append("background", values.background.file);
            }

            await createProduct(formData, values.projectId); 

            notification.success({ message: "Product added successfully!" });
            history("/my-products"); // Redirect to product list
        } catch (error) {
            console.error("Error adding product:", error);
            notification.error({ message: error?.response?.data?.message || "Failed to add product!" });
        } finally {
            setLoading(false);
        }
    };

      const goToHome = useCallback(() => history("/my-products"), [history]);

      
      useEffect(() => {
        const fetchProjects = async () => {
            setProjectsLoading(true);
            try {
                const response = await getProjects();
                if (response.data && response.data.projects) {
                    setProjects(response.data.projects.map((item) => ({
                        label: item.projectName,
                        value: item._id,
                    })));
                }
            } catch (error) {
                console.error("Error fetching projects:", error);
                notification.error({ message: "Failed to load projects!" });
            }
            setProjectsLoading(false);
        };

        fetchProjects();
    }, []);

    console.log({projects})

    return (
        <Layout className="add-product">
        <Header className="add-product__header">
          <div className="header-layout">
            <div className="left">
              <div className="header-brand" onClick={() => history("/")} style={{ cursor: "pointer" }}>
                <img src={Logo} alt="Logo" />
              </div>

              <Button onClick={() => goToHome()}>
                <ArrowLeftOutlined /> Back
              </Button>
            </div>
          </div>
        </Header>

            <Content className="add-product__content">
                <div className="form-container">
                    <Title level={3}>Add New Product</Title>
                    <Form form={form} layout="vertical" onFinish={handleSubmit}>
                        {/* Product Name */}
                        <Form.Item
                            label="Product Name"
                            name="name"
                            rules={[{ required: true, message: "Please enter product name" }]}
                        >
                            <Input placeholder="Enter product name" />
                        </Form.Item>
                        <Form.Item
                            label="Select Project"
                            name="projectId"
                            rules={[{ required: true, message: "Please select a project" }]}
                        >
                            <Select
                                showSearch
                                placeholder="Search & Select Project"
                                optionFilterProp="label" 
                                loading={projectsLoading}
                                filterOption={(input, option) =>
                                    option?.label?.toLowerCase()?.includes(input?.toLowerCase()) 
                                }
                            >
                                {projects.map((project) => (
                                    <Option key={project.value} value={project.value} label={project.label}> 
                                        {project.label} 
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        {/* Product Price */}
                        <Form.Item
                            label="Price"
                            name="price"
                            rules={[{ required: true, message: "Please enter price" }]}
                        >
                            <Input type="number" placeholder="Enter product price" />
                        </Form.Item>

                        {/* Product Description */}
                        <Form.Item
                            label="Description"
                            name="description"
                        >
                            <Input.TextArea rows={4} placeholder="Enter product description" />
                        </Form.Item>



                        {/* Background Image Upload */}
                        <Form.Item
                            label="Upload Background Image"
                            name="background"
                        >
                            <Upload beforeUpload={() => false} maxCount={1}>
                                <Button icon={<UploadOutlined />}>Upload Background</Button>
                            </Upload>
                        </Form.Item>

                        {/* Submit Button */}
                        <Form.Item>
                            <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loading}>
                                Add Product
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Content>
        </Layout>
    );
};

export default AddProduct;
